/*
 current - active page base tag href
 checkAndReload - gets the index page at current location, compares base tags and reloads on change
 */

define('version',[],function () {
	'use strict ';
	var currentURL = baseTagURL(document);

	function baseTagURL(doc) {
		var base = doc.getElementsByTagName('base');

		return base.length > 0 ? base[0].href : null;
	}

	return {
		current: currentURL,
		checkAndReload: function () {
			var request;

			if (!currentURL) {
				return;
			}

			request = new XMLHttpRequest();
			request.open('GET', window.location.href, true);
			request.responseType = 'document';
			request.onload = function () {
				if (this.status !== 200) {
					return;
				}

				if (baseTagURL(this.response) !== currentURL) {
					window.location.reload();
				}
			};
			request.onerror = function () { };
			request.send();
		}
	};
});

